import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/Login.vue";
import AdminDashboard from "../views/AdminDashboard.vue";
import Employees from "../views/Employees.vue";
import Timesheets from "../views/Timesheets.vue";
import Payroll from "../views/Payroll.vue";
import Advances from "../views/Advances.vue";
import EmployeeDashboard from "../views/employee/EmployeeDashboard.vue";
import EmployeeTimesheets from "../views/employee/EmployeeTimesheets.vue";
import EmployeeAdvances from "../views/employee/EmployeeAdvances.vue";
import EmployeePayslips from "../views/employee/EmployeePayslips.vue";
import EmployeeProfile from "../views/employee/EmployeeProfile.vue";

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/dashboard",
    name: "AdminDashboard",
    component: AdminDashboard,
  },
  {
    path: "/employees",
    name: "Employees",
    component: Employees,
  },
  {
    path: "/timesheets",
    name: "Timesheets",
    component: Timesheets,
  },
  {
    path: "/payroll",
    name: "Payroll",
    component: Payroll,
  },
  {
    path: "/advances",
    name: "Advances",
    component: Advances,
  },
  {
    path: "/employee/dashboard",
    name: "EmployeeDashboard",
    component: EmployeeDashboard,
  },
  {
    path: "/employee/timesheets",
    name: "EmployeeTimesheets",
    component: EmployeeTimesheets,
  },
  {
    path: "/employee/advances",
    name: "EmployeeAdvances",
    component: EmployeeAdvances,
  },
  {
    path: "/employee/payslips",
    name: "EmployeePayslips",
    component: EmployeePayslips,
  },
  {
    path: "/employee/profile",
    name: "EmployeeProfile",
    component: EmployeeProfile,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
